import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import QrReader from 'react-qr-reader';
import { formatError, snackbarUtils } from '../../../utils';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  setCode: (value: string) => void;
}

const ScannerDialog = (props: Props) => {
  const { isOpen, handleClose, setCode } = props;
  const classes = useStyles();

  const handleScan = (data: string | null) => {
    if (data) {
      setCode(data);
      handleClose();
    } else return;
  };

  const handleError = (err: any) => {
    console.error(err);
    snackbarUtils.error(formatError(err));
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      className={classes.dialog}
      aria-labelledby="simple-dialog-title"
    >
      <DialogTitle
        id="simple-dialog-title"
        className={classes.title}
      >
        Aponte para o QR Code na mesa
        </DialogTitle>
      <QrReader
        onScan={handleScan}
        delay={300}
        onError={handleError}
        className={classes.scanner}
      />
    </Dialog>
  );
};

export default ScannerDialog;

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    dialog: {
      minWidth: 200,
    },
    title: {
      '& h2': {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightBold,
      }
    },
    scanner: {
      width: '100%',

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 0, 2),
        position: 'unset',
      },

      '& > section': {
        '& > div': {
          // borderRadius: 10,
          boxShadow: `${theme.palette.primary.main} 0px 0px 0px 5px inset !important`,
        },
        '& > video': {
          // borderRadius: 10,
        },
      },
    },
  })
);

